var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );
dependencies["quickshop-header.j2"] = require( "quickshop-header.j2" );
dependencies["quickshop-body.j2"] = require( "quickshop-body.j2" );
dependencies["quickshop-footer.j2"] = require( "quickshop-footer.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("modal/modal-contents.j2", true, "product/templates/quickshop.j2", false, function(t_2,_parentTemplate) {
if(t_2) { cb(t_2); return; }
parentTemplate = _parentTemplate
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
output += t_3;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
output += t_5;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n    c-quickshop__modal\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n    <div class=\"dom-quickshop s-quickshop ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isCartItem")) {
output += " s-quickshop-cart-item ";
;
}
output += " js-quickshop\" data-qa-quickshop-dom>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "showHeader")) {
output += "\n            ";
env.getTemplate("quickshop-header.j2", false, "product/templates/quickshop.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n        ";
})});
}
output += "\n        ";
env.getTemplate("quickshop-body.j2", false, "product/templates/quickshop.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n        ";
env.getTemplate("quickshop-footer.j2", false, "product/templates/quickshop.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n    </div>\n\n";
cb(null, output);
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop.j2"] , dependencies)